(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
  class ProductVideosSection {
    constructor(root) {
      this.root = root;
      this.sliders = Array.from(root.querySelectorAll('[data-product-videos-slider]'));
      this.sliders.forEach((slider) => this.initSlider(slider));
    }

    initSlider(slider) {
      if (slider.dataset.productVideosInitialized === 'true') return;

      const track = slider.querySelector('[data-product-videos-track]');
      const prev = slider.querySelector('[data-product-videos-prev]');
      const next = slider.querySelector('[data-product-videos-next]');
      if (!track) return;

      slider.dataset.productVideosInitialized = 'true';

      const getStep = () => {
        const slide = track.querySelector('.product-videos__slide');
        if (!slide) return track.clientWidth;
        const gap = Number.parseFloat(window.getComputedStyle(track).gap || 0);
        return slide.getBoundingClientRect().width + gap;
      };

      const updateArrows = () => {
        const canScroll = track.scrollWidth > track.clientWidth + 2;
        slider.classList.toggle('is-scrollable', canScroll);

        if (!canScroll) return;

        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      track.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(updateArrows);
        },
        { passive: true }
      );

      window.addEventListener('resize', updateArrows);
      updateArrows();
    }
  }

  const initProductVideos = (container = document) => {
    container.querySelectorAll('[data-product-videos-root]').forEach((root) => {
      new ProductVideosSection(root);
    });
  };

  initProductVideos();

  document.addEventListener('shopify:section:load', (event) => {
    initProductVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
